import { render, staticRenderFns } from "./ClaimCombination.vue?vue&type=template&id=a56f1432&scoped=true&"
import script from "./ClaimCombination.vue?vue&type=script&lang=js&"
export * from "./ClaimCombination.vue?vue&type=script&lang=js&"
import style0 from "./ClaimCombination.vue?vue&type=style&index=0&id=a56f1432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56f1432",
  null
  
)

export default component.exports